var languageConfigs = {
  and: "và",
  retake: "Thử lại",
  tapToTalk: "Trả lời bằng giọng nói",
  typeAnswer: "Nhập câu trả lời của bạn",
  analyzeMyResponse: "Phân tích câu trả lời",
  doneCheckIn: "Hoàn thành trò chuyện",
  done: "Hoàn thành",
  viewResult: "Xem kết quả phân tích",
  viewEmotionBag: "Xem bong bóng cảm xúc",
  close: "Đóng lại",
  nextStep: "Bước kế tiếp",
  listenToEmotion: "Giúp mình bình tĩnh",
  speakOutEmotion: "Trò chuyện cùng mình",
  letsTalk: "Trò chuyện",
  letsStart: "Bắt đầu",
  communitySharing: "Cảm xúc từ cộng đồng dựa trên",
  tryout: "Cùng thử InnerMe bạn nhé!",
  someoneShared: "Ai đó đã chia sẻ rằng",
  youShared: "Bạn đã chia sẻ rằng",
  hi: "Chào",
  friend: "bạn",
  myNameIs: "Tên mình là:",
  you: "bạn",
  yourRating: "Rating của bạn:",
  feedback: "Nhận xét của bạn:",
  next: "Tiếp tục",
  youLook: "#replace{{0}} trông",
  butLittleBit: "nhưng có chút",
  youLookLittleBit: "#replace{{0}} trông có vẻ",
  expressions: {
    angry: "giận dữ",
    disgusted: "disgusted",
    fearful: "lo sợ",
    happy: "hạnh phúc",
    neutral: "bình thản",
    sad: "buồn rầu",
    surprised: "ngạc nhiên"
  }
};

export default languageConfigs;
